<script>
  import {createEventDispatcher} from 'svelte';
  import Big from 'big.js';
  import ValueInput from '@/widgets/ValueInput.svelte';

  export let limit;
  export let isError = false;
  export let needValidate = false;
  export let label = '';
  export let valueEv = 0;
  export let precision = 2;
  export let scale = 2;
  export let tickSizeEv = 1;
  export let factor = 100;
  export let isChangeSelect = false;
  export let minValueEv = 0;
  export let maxValueEv = Infinity;
  export let placeholder;

  const dispatch = createEventDispatcher();

  let input = null;
  let inputValueEv = 0;
  let isFocus = false;
  let placeholderResult = '';

  $: updateInputValueEv(valueEv);
  $: updatePlaceholder(placeholder, precision);

  function updatePlaceholder(placeholder, precision) {
    placeholderResult = placeholder || Number(0.0).toFixed(precision);
  }

  function updateInputValueEv(valueEv) {
    if (inputValueEv !== valueEv && input) {
      if (
        !Big(input.value || 0)
          .times(factor)
          .eq(inputValueEv)
      ) {
        dispatch('change', valueEv);
      }
      inputValueEv = valueEv;
      if (needValidate) {
        validate(valueEv);
      }
    }
  }

  function validate(valueEv) {
    if (isChangeSelect) {
      isChangeSelect = false;
      if (valueEv === 0) {
        return;
      }
    }
    if (!valueEv || valueEv < limit.min || valueEv > limit.max || valueEv > limit.availableEv) {
      isError = true;
    } else {
      isError = false;
    }
  }

  function handleInputClick() {
    input && input.focus();
  }

  function handleInputFocus() {
    isFocus = true;
    dispatch('focus');
  }
  function handleInputBlur() {
    isFocus = false;
    dispatch('blur');
  }
</script>

<style>
  .input-box {
    height: 64px;
  }
  .wrap {
    box-sizing: border-box;
    border: 1px solid #dbdfe7;
    height: 100%;
  }
  .wrap:focus {
    border-color: green;
  }
  .mb4 {
    margin-bottom: 4px;
  }
  .focus {
    border-color: var(--blue);
  }
  .error {
    border-color: #f66;
  }
  .input {
    box-sizing: border-box;
    padding: 12px 0 12px 20px;
    height: 100%;
    cursor: text;
  }
  .wrap :global(.wa) {
    position: unset;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    padding: 0 20px;
    width: 82px;
    min-width: unset;
    height: unset !important;
    background: #f9fafc;
  }
  .wrap :global(.wa ul) {
    top: 64px;
    margin-top: 1px;
    width: unset;
    min-width: 100%;
  }
  .wrap :global(.num) {
    display: flex;
  }
  .wrap :global(.num input) {
    padding: 0;
    width: 100%;
    font-weight: bold;
    font-size: 16px;
    color: var(--T1);
  }
  .wrap :global(.num input::placeholder) {
    font-weight: 500;
    color: var(--T6);
  }
  .input-box :global(.search-input) {
    box-sizing: border-box;
    border: 1px solid #dbdfe7;
    width: 122px;
    height: 64px;
    line-height: 64px;
  }
  .input-box :global(.label) {
    padding: 0;
  }
  .input-box :global(.search-input) {
    background: #f9fafc;
  }
  .input-box :global(.pos-right.dropdown) {
    margin-top: 26px;
  }
</style>

<div class="input-box df">
  <div class="wrap pr df aic f1 jcsb br8" class:focus={isFocus} class:error={isError}>
    <div class="input df aic f1" on:click|stopPropagation={handleInputClick}>
      <label class="db mb4 lh16 f12 fw2 T4">{label}</label>
      <ValueInput
        on:focus={handleInputFocus}
        on:blur={handleInputBlur}
        class="num f1"
        isInline={true}
        operation={false}
        showLabel={false}
        {minValueEv}
        {maxValueEv}
        placeholder={placeholderResult}
        bind:input
        bind:valueEv
        height={20}
        {precision}
        {scale}
        {tickSizeEv}
        {factor}
      />
      <slot name="inputInside" />
    </div>
  </div>
</div>
